/**
 * Layout-only auth stub for Playwright / visual QA.
 * Enable with REACT_APP_E2E_AUTH_STUB=1 on a **dev** server only.
 *
 * Never active in production builds — even if the env var is accidentally set
 * (e.g. leftover shell env from visual QA when running `npm run deploy`).
 *
 * Does not call Firebase — AuthGate treats this as a signed-in, onboarded user.
 */
const stubRequested =
  process.env.REACT_APP_E2E_AUTH_STUB === "1" ||
  process.env.REACT_APP_E2E_AUTH_STUB === "true";

export const E2E_AUTH_STUB_ENABLED =
  stubRequested && process.env.NODE_ENV !== "production";

export const E2E_STUB_USER = {
  uid: "e2e_visual_qa_user",
  email: "visual-qa@therallyally.local",
  displayName: "Visual QA Player",
  isAnonymous: false,
  providerData: [{ providerId: "password" }],
};

export const E2E_STUB_PROFILE = {
  uid: E2E_STUB_USER.uid,
  displayName: "Visual QA Player",
  email: E2E_STUB_USER.email,
  onboardingComplete: true,
};

/** Stable AuthContext value for stub mode. */
export function createE2eAuthContextValue() {
  const noop = async () => ({ user: E2E_STUB_USER, profile: E2E_STUB_PROFILE });
  return {
    user: E2E_STUB_USER,
    profile: E2E_STUB_PROFILE,
    uid: E2E_STUB_USER.uid,
    loading: false,
    googleLinking: false,
    signingIn: false,
    signingOut: false,
    error: null,
    actionError: null,
    clearActionError: () => {},
    pendingProfileOnboarding: false,
    completeProfileOnboarding: () => {},
    isAuthenticated: true,
    isAnonymous: false,
    hasGoogle: false,
    hasPassword: true,
    linkGoogle: noop,
    signInWithGoogle: noop,
    signInWithRallyAlly: noop,
    registerRallyAlly: noop,
    signOut: async () => {},
    ensureSessionReady: async () => E2E_STUB_USER.uid,
  };
}
